(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      // Bezpieczne wywołanie - sprawdź czy obiekt istnieje
      if (typeof theme !== 'undefined' 
          && theme.ProductBlockManager 
          && typeof theme.ProductBlockManager.loadImages === 'function') {
        theme.ProductBlockManager.loadImages(productRecommendationsSection);
      }

      if (typeof theme !== 'undefined' 
          && typeof theme.initAnimateOnScroll === 'function') {
        theme.initAnimateOnScroll();
      }
    }
  };
  request.send();
};

// Editor reload
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});

// Poczekaj na pełne załadowanie strony zanim pobierzesz rekomendacje
if (document.readyState === 'complete') {
  loadProductRecommendationsIntoSection();
} else {
  window.addEventListener('load', loadProductRecommendationsIntoSection);
}

  } catch(e) { console.error(e); }
})();
})();
